import { TransitionsOptions } from '@material-ui/core/styles';

export const transitions: TransitionsOptions = {
  duration: {
    standard: 0.3,
  },
};
